<style lang="stylus">
    .InsertContainer-mask
        modal-mask()
        .InsertContainer-modal
            height: 396px
            width 577px
            .dialog-slot{
              padding-top: 8px
            }
            .InsertContainer-container
                margin: 0 -8px
                overflow auto
                display flex
                flex-wrap wrap
                .InsertContainer-container-itembox
                    display flex
                    flex-wrap wrap
                    width 20%
                    padding 8px
                    .InsertContainer-container-item
                        display flex
                        flex-wrap wrap
                        align-items center
                        justify-content center
                        border: 1px solid var(--border-color-box-6);
                        border-radius: $box-radius;
                        width 92px
                        height 82px
                        padding-bottom 5px
                        transition border .2s linear
                        user-select none
                        cursor pointer
                        img
                            width 48px
                            height 48px
                        p
                            width 100%
                            overflow hidden
                            white-space nowrap
                            text-overflow ellipsis
                            text-align center
                        &:hover,&.active
                            border 1px solid var(--themeHover)
</style>

<template>
    <div class="InsertContainer-mask">
        <Dialog class="InsertContainer-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="InsertContainer-container">
                <div class="InsertContainer-container-itembox" v-for="item in dataList" :key="item.table_index">
                    <div
                        class="InsertContainer-container-item"
                        :class="{ active: currentIndex == item.table_index }"
                        @dblclick="addItem(item)"
                        @click="selectItem(item)"
                    >
                        <img :src="item.url" alt="" />
                        <p>{{ item[lang] ? item[lang] : item.imgname }}</p>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class InsertContainer extends Vue {
        @Inject()
        ["showMessage"];

        dataList: Array<object> = [];
        currentIndex: number = -1;
        tempItem: object;

        mapSort(linkedList) {
            var sortedList = [];
            var map = new Map();
            var currentId = null;

            for (var i = 0; i < linkedList.length; i++) {
                var item = linkedList[i];
                if (item.next === null) {
                    currentId = item.table_index;
                    sortedList.push(item);
                } else {
                    map.set(item.next, i);
                }
            }

            while (sortedList.length < linkedList.length) {
                var previousItem = linkedList[map.get(currentId)];
                sortedList.unshift(previousItem);
                currentId = previousItem.table_index;
            }

            return sortedList;
        }
        initData() {
            const GROUP_NAME = "General",
                TABLE_NAME = "Container";
            let tempData = [];
            let opendb = window.indexedDB.open(GROUP_NAME);
            opendb.onsuccess = (e) => {
                let db = (e.target as IDBOpenDBRequest).result;
                let transaction = db.transaction(TABLE_NAME);
                let store = transaction.objectStore(TABLE_NAME);
                let request = store.openCursor();
                request.onsuccess = (e) => {
                    let cursor = (e.target as IDBRequest).result;
                    if (cursor) {
                        let cursordata = cursor.value;
                        let cursorkey = cursor.key;
                        let tempIMG = cursordata.data.match(/!\[CDATA\[[^\[\]]*?\]\]/g);
                        if (cursorkey == 0) {
                            tempData[0] = {
                                table_index: cursordata.index,
                                imgname: cursordata.name,
                                zh: cursordata.zh_name,
                                de: cursordata.de_name,
                                en: cursordata.en_name,
                                es: cursordata.es_name,
                                fr: cursordata.fr_name,
                                jp: cursordata.jp_name,
                                ru: cursordata.ru_name,
                                it: cursordata.it_name,
                                pt: cursordata.pt_name,
                                url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                blob: cursordata.blob,
                                shape: cursordata.data,
                                table_id: cursordata.tableID,
                                tempIMG: tempIMG ? tempIMG : [],
                                next: cursordata.next,
                            };
                        } else {
                            let obj = {
                                table_index: cursordata.index,
                                imgname: cursordata.name,
                                zh: cursordata.zh_name,
                                de: cursordata.de_name,
                                en: cursordata.en_name,
                                es: cursordata.es_name,
                                fr: cursordata.fr_name,
                                jp: cursordata.jp_name,
                                ru: cursordata.ru_name,
                                it: cursordata.it_name,
                                pt: cursordata.pt_name,
                                url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                blob: cursordata.blob,
                                shape: cursordata.data,
                                table_id: cursordata.tableID,
                                tempIMG: tempIMG ? tempIMG : [],
                                next: cursordata.next,
                            };
                            tempData.push(obj);
                        }
                        cursor.continue();
                    } else {
                        if (tempData.length > 0) {
                            this.dataList = this.mapSort(tempData);
                            this.selectItem(this.dataList[0]);
                        }
                    }
                };
                db.close();
            };
            opendb.onerror = (e) => {
                console.log(e);
            };
        }

        selectItem(item) {
            this.currentIndex = item.table_index;
            this.tempItem = item;
        }
        addItem(item) {
            // 双击直接添加
            const CONTAINER_GROUPID = 11;
            let view = window["_view"];
            let content = item["shape"],
                nameU = item["imgname"],
                localName = item[this.lang] || nameU,
                libId = CONTAINER_GROUPID;
            view.createContainer2(content, nameU, localName, libId);
            this.sensors.track("insertContainer", {
                Catalogues: "SpecificFunctions",
                container_name: nameU,
            });
            this.closeModal();
        }
        confirm() {
            if (this.currentIndex == -1) return;
            const CONTAINER_GROUPID = 11;
            let view = window["_view"];
            let content = this.tempItem["shape"],
                nameU = this.tempItem["imgname"],
                localName = this.tempItem[this.lang] || nameU,
                libId = CONTAINER_GROUPID;
            view.createContainer2(content, nameU, localName, libId);
            this.sensors.track("insertContainer", {
                Catalogues: "SpecificFunctions",
                container_name: nameU,
            });
            this.closeModal();
        }
        cancel() {
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {
            this.initData();
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "插入容器",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Insert Container",
    "confirm": "Insert",
    "cancel": "Cancel"
  },
  "fr": {
    "title": "Insérer un conteneur",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "title": "Behälter einsetzen ",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "title": "コンテナを挿入",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "es": {
    "title": "Insertar contenedor",
    "confirm": "Insertar",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Inserir recipiente",
    "confirm": "Inserir",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Inserisci contenitore",
    "confirm": "Inserisci",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "插入容器",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "컨테이너 삽입",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
